<template>
    <div>
        <b-row>
            <b-col cols="12">
                <h1>
                    <b-button variant="outline-primary" @click="$emit('back')">
                        <i class="fas fa-arrow-left"></i></b-button>
                    Pre-License > Project Timeline > Step {{current_step}} of {{total_steps}}
                </h1>
            </b-col>
            <b-col cols="12">
                <b-progress id="totalSteps" striped :max="total_steps" height="1rem" style="border 1px solid lightgrey; !important" >
                    <b-progress-bar :value="current_step" variant="success"></b-progress-bar>
                </b-progress>
            </b-col>
        </b-row>
    </div>
</template>

<script>
import _ from 'lodash'
import { ccbAdminState } from '@/state/helpers.js'
export default {
    data:() => ({
        current_step: 0,
        total_steps: 0,
    }),
    computed:{
        ...ccbAdminState,
    },
    methods:{
        currentStep(){
            let current = 0;
            if(this.client_data != null && this.client_step_data != null){
                let index = _.findIndex(this.client_data.appllication.steps, {id:this.client_step_data.id});
                if(index != -1){
                    current = index + 1;
                }
            }
            
            this.current_step = current;
        },
        totalSteps(){
            let total = 0;
            if(this.client_data != null){
                total = this.client_data.appllication.steps.length;
            }
            
            this.total_steps = total;
        }
    },
    mounted(){
        this.$nextTick(()=>{
            this.currentStep();
            this.totalSteps();
        })
    },
}
</script>

<style>
#totalSteps{
    background-color: #dadada;
}
</style>